const getLinkPreview = async ({ dispatch }, link) => {
    try {
        const response = await window.axios.post('/proxy/utils/get-link-preview', { link });
        return response.data;
    } catch (error) {
        dispatch('notifications/setError', error.message, { root: true });
    }
};

export default getLinkPreview;
